import {
	EstimatedDeliveryDates,
	UseEstimatedDeliveryDatesOptions,
} from '@/data/Content/EstimatedDeliveryDates/types';
import { getResolvedDeliveryDate } from '@/data/Content/EstimatedDeliveryDates/utils';
import { useHomeDeliveryDate } from '@/data/Content/HomeDeliveryDate';
import { usePickupDate } from '@/data/Content/PickupDate';
import { ProductType } from '@/data/types/Product';
import { useMemo } from 'react';
import { getStoreIdAndStateId } from 'shared/custom/utils/cookieHandler';

export const useEstimatedDeliveryDates = (
	product: ProductType | undefined,
	{ enabled = true, physicalStoreId }: UseEstimatedDeliveryDatesOptions = {}
): EstimatedDeliveryDates => {
	const storeId = physicalStoreId ?? getStoreIdAndStateId().stLocId;
	const target = enabled ? product : undefined;
	const homeDelivery = useHomeDeliveryDate(target, storeId);
	const pickup = usePickupDate(target, storeId);

	return useMemo(
		() => ({
			homeDeliveryDate: getResolvedDeliveryDate(homeDelivery),
			pickupDate: getResolvedDeliveryDate(pickup),
		}),
		[homeDelivery, pickup]
	);
};
